import { ProjectedNotification } from '../../notifications/notification.utils';
import { SocketRoomEvent, TenantNotificationPayload } from '../tenant.notification.payload';
import { RoomKey } from '../socket.room.key';

/** Event types emitted to inbox room */
export const InboxEventType = {
    UnreadCount: 'unread-count',
    QueueNavigationInvalidated: 'queue-navigation-invalidated',
    Created: 'created',
    Read: 'read',
    Unread: 'unread',
    Snoozed: 'snoozed',
    Unsnoozed: 'unsnoozed',
    Deleted: 'deleted',
    Cleared: 'cleared',
    MarkedAllRead: 'marked-all-read',
    MarkedAllUnread: 'marked-all-unread',
} as const;

export const QueueNavigationInvalidationSource = {
    Config: 'queue-config',
    Count: 'queue-count',
    Data: 'queue-data',
} as const;

export type QueueNavigationInvalidationSource = typeof QueueNavigationInvalidationSource[keyof typeof QueueNavigationInvalidationSource];

export type InboxRoomMessage =
    | SocketRoomEvent<typeof InboxEventType.UnreadCount, { count: number }>
    | SocketRoomEvent<typeof InboxEventType.QueueNavigationInvalidated, { queueIds: string[]; source: QueueNavigationInvalidationSource; queueCounts?: { queueId: string; count: number }[] }>
    | SocketRoomEvent<typeof InboxEventType.Created, ProjectedNotification>
    | SocketRoomEvent<typeof InboxEventType.Read, ProjectedNotification>
    | SocketRoomEvent<typeof InboxEventType.Unread, ProjectedNotification>
    | SocketRoomEvent<typeof InboxEventType.Snoozed, ProjectedNotification>
    | SocketRoomEvent<typeof InboxEventType.Unsnoozed, ProjectedNotification>
    | SocketRoomEvent<typeof InboxEventType.Deleted, { notificationId: string; readAt?: Date | null }>
    | SocketRoomEvent<typeof InboxEventType.Cleared, { recipientId: string; deletedCount: number; onlyRead?: boolean }>
    | SocketRoomEvent<typeof InboxEventType.MarkedAllRead, { recipientId: string; updatedCount: number }>
    | SocketRoomEvent<typeof InboxEventType.MarkedAllUnread, { recipientId: string; updatedCount: number }>;

export const InboxRooms = {
    inbox: (userId: string): RoomKey<InboxRoomMessage> => ({ key: `inbox:${userId}` }),
    team: (teamId: string): RoomKey<TenantNotificationPayload> => ({ key: `team:${teamId}` }),
};
